export default __webpack_public_path__ + "static/media/moon.ab12787f.svg";